import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../common/redux/reduxHooks";
import { DisponibiliteStructure } from "../structures/model/StructureModel";
import { StructureCard } from "../cards/StructureCard";
import { Box, CircularProgress, Typography } from "@mui/material";
import { getNotificationDisponibilityStructure } from "../common/redux/notificationActions";
import { useTranslation } from "react-i18next";

export const NotificationProjectPage = (): JSX.Element => {
    const { id } = useParams();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const [structure, setStructure] = useState<DisponibiliteStructure | null>(
        null
    );
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            dispatch(getNotificationDisponibilityStructure(id))
                .unwrap()
                .then((structureData: DisponibiliteStructure) => {
                    setStructure(structureData);
                })
                .catch((e: string) => console.error("Eroare la fetch:", e))
                .finally(() => setLoading(false));
        }
    }, [dispatch, id]);

    const administrativeArea = structure?.administrativeArea?.name
        ? `, ${structure.administrativeArea.name}`
        : "";

    const country = structure?.country?.name || "";

    const startDate = structure?.dateDemarrage
        ? new Date(structure.dateDemarrage).toLocaleDateString("fr-FR")
        : "";

    const endDate = structure?.dateFin
        ? new Date(structure.dateFin).toLocaleDateString("fr-FR")
        : "";

    if (loading) {
        return (
            <Box
                textAlign="center"
                height="100dvh"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
            >
                <CircularProgress />
                <Typography mt={2}>{t("inputPlaceholders.loading")}</Typography>
            </Box>
        );
    }

    if (!structure) {
        return (
            <Box
                textAlign="center"
                height="100dvh"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="h3" color="text.secondary">
                    {t("notification.notFound")}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            mt={10}
            display="flex"
            flexDirection="column"
            alignItems="center"
            px={2}
        >
            {/* <Typography variant="h5" fontWeight="bold" textAlign="center">
                {structure.profession
                    ? t("notification.structure.title", {
                          profession: getTranslatedProfessionName(
                              structure.profession
                          ),
                      })
                    : t("notification.structure.defaultTitle")}
            </Typography> */}
            <Typography
                variant="subtitle1"
                textAlign="center"
                color="text.secondary"
                mb={4}
            >
                {structure.ville
                    ? t("notification.structure.subtitle", {
                          ville: structure.ville,
                          administrativeArea: administrativeArea,
                          country: country,
                          startDate,
                          endDate,
                      })
                    : ""}
            </Typography>
            <StructureCard {...structure} />
        </Box>
    );
};
